<template>
  <div class="container justify-content-center mt-5 form-base">
    <b-form ref="frmOrderCompanyCreate" @submit.stop.prevent="processCompanyProfileUpdate" class="pl-3 pr-3">
      <!-- <div class="row">
        <div class="col-md-6">
          <my-input
            id="first-name"
            name="first-name"
            label="First Name"
            placeholder="Andrew"
            inlinerows="false"
            classes="bg-gray"
          ></my-input>
        </div>
        <div class="col-md-6">
          <my-input
            id="last-name"
            name="last-name"
            label="Last Name"
            placeholder="Haagendazs"
            inlinerows="false"
            classes="bg-gray"
          ></my-input>
        </div>
      </div> -->

      <div class="row">
        <div class="col-md-6">
          <my-input id="email" name="email" :label="$t(LangConstants.company_email_input_label)" placeholder="help@theboringcompany.com" inlinerows="false" classes="bg-gray" type="email" ref="companyEmail" :defaultText="companyFormObject.email" v-model="companyFormObject.email" :error="companyFormObject$.email.$error == true ? companyFormObject$.email.$errors[0].$message : ''"></my-input>
        </div>
        <div class="col-md-6">
          <my-input id="company-no" name="company-no" :label="$t(LangConstants.company_number_input_label)" placeholder="1231232" inlinerows="false" classes="bg-gray" ref="orgNumber" :defaultText="companyFormObject.organization_number" v-model="companyFormObject.organization_number" :error="companyFormObject$.organization_number.$error == true ? companyFormObject$.organization_number.$errors[0].$message : ''"></my-input>
        </div>
      </div>
      <div class="row">
        <div class="col-md-6">
          <my-input id="company-name" name="company-name" :label="$t(LangConstants.company_name_input_label)" placeholder="The Boring Company" inlinerows="false" classes="bg-gray" ref="companyname" :defaultText="companyFormObject.name" v-model="companyFormObject.name" :error="companyFormObject$.name.$error == true ? companyFormObject$.name.$errors[0].$message : ''"></my-input>
        </div>
        <div class="col-md-6">
          <my-input id="phone" name="phone" :label="$t(LangConstants.phone_input_label)" placeholder="+333333332222" inlinerows="false" classes="bg-gray" ref="companyPhone" :defaultText="companyFormObject.phone" v-model="companyFormObject.phone" :error="companyFormObject$.phone.$error == true ? companyFormObject$.phone.$errors[0].$message : ''"></my-input>
        </div>
      </div>

      <!-- <hr /> -->
      <!-- <h5><b>Set Password</b></h5>
      <div class="row">
        <div class="col-md-6">
          <my-input
            id="password"
            name="password"
            label="Password"
            placeholder=""
            inlinerows="false"
            classes="bg-gray"
          ></my-input>
        </div>
        <div class="col-md-6">
          <my-input
            id="password-confirmation"
            name="password-confirmation"
            label="Re-enter Password"
            placeholder=""
            inlinerows="false"
            classes="bg-gray"
          ></my-input>
        </div>
      </div> -->
      <div class="row">
        <div class="col-md-12">
          <div class="mb-4">
            <my-button fa="floppy-o" :label="$t(LangConstants.save_changes_button_label)" variant="solid-primary" classes="mr-1" height="56px" width="100%" type="submit"></my-button>
          </div>
        </div>
      </div>
    </b-form>
  </div>
</template>

<script>
/**
 * Company Profile Page
 */
import MyInput from "../../components/atoms/Input.vue";
import MyButton from "../../components/atoms/Button.vue";

import useValidate from "@vuelidate/core";
import { required, email /*, helpers */ } from "@vuelidate/validators";
import { reactive } from "@vue/composition-api";
import Constants from "../../constants/index";
// import common from "../../../functions/index";
//  import Customers from "../../apis/Customers";

export default {
  name: "company-subscription",
  async beforeCreate() {},
  async created() {
    // await Customers.customerinstanceNotify();

    this.$store
      .dispatch("getCustomer")
      .then((customer) => {
        this.companyFormObject.id = customer["id"];

        this.$refs.companyEmail.text = customer["email"];
        this.$refs.companyname.text = customer["name"];
        this.$refs.orgNumber.text = customer["organization_number"];
        this.$refs.companyPhone.text = customer["phone"];

        this.companyFormObject.email = customer["email"];
        this.companyFormObject.name = customer["name"];
        this.companyFormObject.organization_number = customer["organization_number"];
        this.companyFormObject.phone = customer["phone"];
      })
      .catch((error) => {
        this.$fire({
          title: this.$t(this.LangConstants.customer_profile_retrieval_error_heading),
          text: this.$t(this.LangConstants.customer_profile_retrieval_status_heading),
          type: "error",
          html: "<div>" + this.$t(error) + "</div>",
        }).then(() => {});
      });
  },
  setup() {
    const companyFormObject = reactive({
      id: null,
      email: "",
      organization_number: "",
      name: "",
      phone: "",
    });

    const companyFormObjectRules = {
      email: { required, email },
      organization_number: { required },
      name: { required },
      phone: { required },
    };

    const companyFormObject$ = useValidate(companyFormObjectRules, companyFormObject);

    return {
      companyFormObject,
      companyFormObject$,
    };
  },
  data() {
    return {};
  },

  methods: {
    async processCompanyProfileUpdate() {
      this.companyFormObject$.$validate();
      const validated = this.companyFormObject$.$error == true ? false : true;
      if (validated == true) {
        this.$store
          .dispatch("updateOwnCustomer", { customer: this.companyFormObject })
          .then(() => {
            this.$fire({
              title: this.$t(this.LangConstants.customer_profile_update_success_heading),
              text: this.$t(this.LangConstants.customer_profile_update_success_message),
              type: "success",
              // html: "<div>" + error + "</div>",
            }).then(() => {});
          })
          .catch((error) => {
            this.$fire({
              title: this.$t(this.LangConstants.customer_profile_update_status_heading),
              text: this.$t(this.LangConstants.customer_profile_update_error_message),
              type: "error",
              html: "<div>" + this.$t(error) + "</div>",
            }).then(() => {});
          });
      }
    },
  },
  computed: {
    LangConstants() {
      return Constants;
    },
  },

  components: {
    MyInput,
    MyButton,
  },
};
</script>
